import { Flex } from "@chakra-ui/layout"
import { Spinner } from "@chakra-ui/spinner"

const ShowCardLoaderOverlay = ({ color }: { color: string }) => {
  return (
    <Flex
      position="absolute"
      width="full"
      height="full"
      backgroundColor="rgba(51,51,51,0.75)"
      color={color}
      justify="center"
      align="center"
      userSelect="none"
      direction="column"
    >
      <Spinner />
    </Flex>
  )
}

export default ShowCardLoaderOverlay
